import React from 'react';
import PropTypes from 'prop-types';

const Cancel = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5949 3.41241C14.5127 3.33009 14.4151 3.26479 14.3076 3.22023C14.2002 3.17567 14.085 3.15274 13.9687 3.15274C13.8523 3.15274 13.7371 3.17567 13.6297 3.22023C13.5222 3.26479 13.4246 3.33009 13.3424 3.41241L8.99991 7.74741L4.65741 3.40491C4.57517 3.32267 4.47754 3.25743 4.37008 3.21292C4.26263 3.16842 4.14746 3.14551 4.03116 3.14551C3.91485 3.14551 3.79969 3.16842 3.69223 3.21292C3.58478 3.25743 3.48715 3.32267 3.40491 3.40491C3.23882 3.571 3.14551 3.79627 3.14551 4.03116C3.14551 4.26605 3.23882 4.49132 3.40491 4.65741L7.74741 8.99991L3.40491 13.3424C3.23882 13.5085 3.14551 13.7338 3.14551 13.9687C3.14551 14.2035 3.23882 14.4288 3.40491 14.5949C3.571 14.761 3.79627 14.8543 4.03116 14.8543C4.26605 14.8543 4.49132 14.761 4.65741 14.5949L8.99991 10.2524L13.3424 14.5949C13.5085 14.761 13.7338 14.8543 13.9687 14.8543C14.2035 14.8543 14.4288 14.761 14.5949 14.5949C14.761 14.4288 14.8543 14.2035 14.8543 13.9687C14.8543 13.7338 14.761 13.5085 14.5949 13.3424L10.2524 8.99991L14.5949 4.65741C14.7571 4.49078 14.8478 4.26743 14.8478 4.03491C14.8478 3.80238 14.7571 3.57904 14.5949 3.41241Z"
      fill={fill || 'var(--SECONDARY_DARK)'}
    />
  </svg>
);

Cancel.propTypes = {
  fill: PropTypes.string,
};

export default Cancel;
